import { downloadDOM } from '../../../general/utils/download';
import { CHNode, CHNodeIsFolder } from '../../../general/node';
import { urlDownload, urlZip, urlZipShare } from '../../../general/urls';
import { _select, ListenerApiLight, lm } from '../../listenerMiddleware';
import { logger } from '../../logger';
import { Page } from '../../models/page';
import { getPage, getShareID } from '../app/selectors';
import * as fileManagerActions from '../fileManager/actions';
import { getSelectedNodesInAllFolders } from '../fileManager/selectors/selectors';
import * as downloaderActions from './actions';

export function downloaderRootListener() {
  lm.takeEvery(downloaderActions.downloadButtonClicked, (_, lapi) => {
    const nodes = _select(lapi, getSelectedNodesInAllFolders);
    if (nodes.length === 1 && CHNodeIsFolder(nodes[0]) === false) {
      downloadSingle(lapi, nodes[0]);
    } else {
      downloadMultiple(
        lapi,
        nodes.map((node) => node.id),
      );
    }
    logger.lapi(lapi, {
      action: 'File',
      sub_action: 'Download',
      extra: { node_ids: nodes.map((x) => x.id) },
    });
    lapi.dispatch(fileManagerActions.allDeselected({}));
  });
}

export const downloadSingle = function (lapi: ListenerApiLight, node: CHNode) {
  const shareID = _select(lapi, getShareID);

  const href = urlDownload({
    nodeID: node.id,
    shareID: shareID ?? undefined,
    downloadURL: node.download_url ?? undefined,
  });

  downloadDOM(href);
};

export const downloadMultiple = function (lapi: ListenerApiLight, nodeIds: number[]) {
  const page = _select(lapi, getPage);
  let href = '';

  if (page === Page.SHARED_FOLDER) {
    const shareId = _select(lapi, getShareID);
    href = urlZipShare(shareId ?? '', nodeIds);
  } else {
    href = urlZip(nodeIds);
  }

  downloadDOM(href);
};
